/**
 * BasePermissionConfig interface that should be implemented
 * by frontends when a full PermissionConfig is needed.
 *
 * This instance is made so that systems in Mead have something to
 * work with for type support.
 */
class BasePermissionConfig {
    hasAccess() {
        return true;
    }
    clone() {
        return new BasePermissionConfig();
    }
}
export { BasePermissionConfig };
//# sourceMappingURL=IPermissionConfig.js.map